/**
 * Created by contrapro on 03/04/2018
 */

// You shouldn't import from 'rxjs' or 'rxjs/Rx' since either import will import the whole of rxjs which will dramatically increase the size of your bundle.
// This should be changed in the docs to import { Observable } from 'rxjs/Observable ';
// import { Observable } from 'rxjs/Observable';

// rxjs 6 alpha
// import { Observable, of} from 'rxjs';
// import { map, switchMap,filter, merge, mergeMap } from 'rxjs/operators';
// import { map } from 'rxjs/operators/map';
// import { switchMap } from 'rxjs/operators/switchMap';
// import { filter } from 'rxjs/operators/filter';
// import { mergeMap } from 'rxjs/operators/mergeMap';


// rxjs 5
// import { Observable } from 'rxjs/Observable';
// import 'rxjs/add/observable/of';
//
// import { push } from 'react-router-redux';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/mergeMap';


import {
    ACTION_TYPE_LOGIN, loginResult, epicCatchError, loginError,
    // messageResult, messageError,
    showRichModal, loadWishes,loadLightCollect,
    updateLocalUser, redirectTo
} from '../actions';
import { api } from '../service/AppService';

//switchMap 操作符用于对源 Observable 对象发出的值，做映射处理。
// 若有新的 Observable 对象出现，会在新的 Observable 对象发出新值后，
// 退订前一个未处理完的 Observable 对象。
export default function login(action$, store) {
    return action$.ofType(ACTION_TYPE_LOGIN)
        .switchMap(action => {
            return api.login(action.payload.sceneData)
            //mergeMap是并发
                .mergeMap(res => {
                    //重定向
                    if (res.body.status === 302) {
                        //console.log('//重定向');
                        window.location.replace(res.body.text);
                        return Observable.merge(
                            Observable.of(redirectTo((res.body.text))),
                        );
                    }

                    const p = (res.body && res.body.extraParam) ? res.body.extraParam : {};
                    if (p.openid && p.openid !== null && p.openid.length > 0) {
                        window._vio.push(['_setUserID', p.openid]);
                        window._vio.push(['_trackPageview']); //_setUserID 要在 _trackPageview 之前设置
                        //
                        //
                        // //DGS 系统
                        // window.mixpanel.register({
                        //     'uid': p.openid, //（必填）此处的uid为当前用户的唯一id,如果是微信则为微信授权后的openid,如果是微博则是微博授权后的uid等等，如无法拿到平台授权的uid，可用cookie代替
                        //     'srcuid': '',//（选填）此处的srcuid为带来当前uid用户的uid,这个变量微信中多用即来源openid
                        //     'platform': 'wechat',//（必填）不同渠道，媒体定义在这个变量中 如wechat、weibo、youku……
                        //     'urlid': 'index'//（必填）此变量为当前页面的标识，如 系统首页：index ，注册页：register 等等。
                        // });

                    }

                    return Observable.merge(
                        Observable.of(loginResult(res.body.session, res.body.extraParam)),
                        Observable.of(updateLocalUser(res.body.text)),
                        Observable.of(loadWishes(false)),   //加载全场许愿瓶，user也被展开，为了显示速度。TODO 这里要考虑下，是否做limit限制
                        Observable.of(loadLightCollect(true)), //加载我收集的光
                        // Observable.of(loadMessage(res.body.text.objectId)),
                    );
                })
                .catch(error => {
                    return Observable.merge(
                        Observable.of(showRichModal({
                            title: 'Error ' + 'login_epic',
                            content: error.status + ' ' + error.toString(),
                        })),
                        Observable.of(loginError(error)),
                        Observable.of(epicCatchError(error, 'login_epic'))
                    )
                });
        })

}



// WEBPACK FOOTER //
// ./src/epics/login.js